import React from 'react'
import { v4 as uuidv4 } from 'uuid';

const PrintPills = (props) => {
    return(<>
        {
            (props.element !== 'Ungrouped')? <p className="para-text italicstyling">{props.element}</p>:''
        }
        {props.data[props.element].map(skillName => {
            return <span key={uuidv4()} className="pill-primary">{skillName}<span className="seperator">,</span> </span>
        })}
    </>)
}


function Skills(props) {
    const predefinedGroups = ['Ungrouped','Project Planning & Management','Programming','Web Technologies','Database Technologies','Business & Management','Data & Analysis','Software Skills','Accounting','Aviation','Other Skills','Special Skills'];
    return (
        <>
           <p className="heading-text">SKILLS</p>
            <div className="skill-container">
                {
                    predefinedGroups.map(element => {
                        if(props.data[element] !== undefined && props.data[element] !== null && props.data[element].length !== 0)
                        {
                            return(
                                <div key={uuidv4()} className="para-text skill-list">
                                    <PrintPills element={element} data={props.data}/>
                                </div>
                            )
                        }
                        return true;
                    })
                }
            </div> 
        </>
    )
}

export default Skills
